import type { BillingStatus, PlanKey } from "@atlas/shared";
import { apiGet, apiPost, apiDelete } from "../lib/api-client";

export type { BillingStatus, PlanKey } from "@atlas/shared";

export function fetchBillingStatus(): Promise<BillingStatus> {
  return apiGet("/billing");
}

export function startCheckout(interval: "month" | "year" = "month"): Promise<{ url: string }> {
  return apiPost("/billing/checkout", { interval });
}

/** Full history one-off (spec 30): Stripe Checkout in payment mode. 409 already_unlocked, 503 beta_gate. */
export function startFullHistoryCheckout(): Promise<{ url: string }> {
  return apiPost("/billing/full-history/checkout");
}

export function openBillingPortal(): Promise<{ url: string }> {
  return apiPost("/billing/portal");
}

/** Dismisses the free-plan history notice (dashboard card). Server-side so it stays dismissed across devices. */
export function dismissHistoryNotice(): Promise<{ ok: boolean; dismissedAt: string }> {
  return apiPost("/billing/history-notice/dismiss");
}

export function redeemKey(
  code: string,
): Promise<{ ok: boolean; plan: string; expiresAt: string | null }> {
  return apiPost("/billing/redeem-key", { code });
}

export function fetchAdminPlanKeys(): Promise<{ keys: PlanKey[] }> {
  return apiGet("/admin/plan-keys");
}

export function createPlanKey(data: {
  plan?: string;
  durationDays?: number;
  note?: string;
}): Promise<{ key: PlanKey }> {
  return apiPost("/admin/plan-keys", data);
}

export function deletePlanKey(keyId: string): Promise<{ ok: boolean }> {
  return apiDelete(`/admin/plan-keys/${keyId}`);
}
